import { UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BookingDetails.css';

export interface IDetail {
  label: string;
  text: string;
}

export interface IBookingDetailsProps {
  details: IDetail[];
}

export const BookingDetails: React.FC<IBookingDetailsProps> = ({ details }) => {
  return (
    <div className={styles['details']}>
      {details.map(item => (
        <div className={styles['details-item']} key={item.label}>
          <div className={styles['details-item__label']}>
            <UIText2 color="gray60_100">{item.label}</UIText2>
          </div>
          <UIText1 display="block">{item.text}</UIText1>
        </div>
      ))}
    </div>
  );
};
